import React from 'react';
import { StyledTextbox } from '@nib-components/textbox';
import BaseFormField from '../base-form-field';
import { AddFunnelPropFromContext } from '../funnel-context';
import MaskedInput from 'react-text-mask';
import { FUNNELS, LABELS as DEFAULT_LABELS } from '../../util/constants';
import { defaultFieldPropTypes } from '../../types';
const LABELS = {
  ARHI: DEFAULT_LABELS.PHONE_NUMBER
};
const HELP_TEXTS = {
  ARHI: '',
  IWHI: 'Your mobile number should start with 0 or your country code, and landline numbers with your area code.',
  IMAN: 'Your mobile number should start with 0 or your country code, and landline numbers with your area code.'
};
const mask = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]; // 15 digits is our max
export const Phone = props => {
  const {
    funnel = FUNNELS.ARHI,
    help = '',
    width = 10,
    optional = false,
    required
  } = props;
  return React.createElement(BaseFormField, {
    ...props,
    label: props.label || LABELS[funnel] || LABELS.ARHI,
    help: help || HELP_TEXTS[funnel] || HELP_TEXTS.ARHI,
    funnel: funnel,
    width: width,
    optional: optional,
    required: required
  }, React.createElement(MaskedInput, {
    guide: false,
    mask: mask,
    ...props.field,
    render: (ref, props) => React.createElement(StyledTextbox, {
      ref: ref,
      ...props,
      type: "tel",
      autoComplete: "tel",
      pattern: "\\d*"
    })
  }));
};
Phone.defaultProps = {
  ...defaultFieldPropTypes,
  width: 10
};
const PhoneWithFunnel = props => React.createElement(AddFunnelPropFromContext, null, React.createElement(Phone, {
  ...props
}));
export default PhoneWithFunnel;